<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-indent:0em !important; padding-top:150px;">This book is not a book. I know how that sounds but hear me out. It is not designed to be your conventional drama or paved out action thriller. It just wants to make you think. About something, anything; about the world, about others, about yourself because you are important. If it makes no sense, that’s a shame. If it does, then you and I need to meet. For all intents and purposes, enjoy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6b21c824